var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{attrs:{"align-with-title":""}},[_c('v-tab',{on:{"click":function($event){return _vm.seleccion(2)}}},[_vm._v("Reguladores")]),_c('v-tab',{on:{"click":function($event){return _vm.seleccion(1)}}},[_vm._v("Principal")]),_c('v-tab',{on:{"click":function($event){return _vm.seleccion(0)}}},[_vm._v("Secadero")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }